import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useNeomem } from '../application'
import { useGlobals } from '../application'
import Markdown from '../../packages/markdown'
import ExternalLink from '../../packages/external-link'
import './styles.css'


//. will want to cache data in neomem, but don't persist place details to db (or could for 24hrs?)

const hideBehindButton = false

export default observer(() => {

  // const [showDetails, setShowDetails] = useState(false)
  // const [showDetails, setShowDetails] = useState(true)
  const [showDetails, setShowDetails] = useState(!hideBehindButton)
  const [details, setDetails] = useState(null)

  const neomem = useNeomem()
  const globals = useGlobals()
  const currentNodeId = neomem.currentNodeId //. mobx problem?
  const place = neomem.getNode(currentNodeId)
  if (!place) return null
  
  // can fetch stuff async here - ie when place changes
  useEffect(() => {
    fetchDetails()
    // reset details button each place change
    if (hideBehindButton) {
      setShowDetails(false)
    }
  }, [place && place.id])

  function fetchDetails() {
    // need maps, map to be ready - wait for them
    // note: placeId is the google map's placeId
    // see https://developers.google.com/maps/documentation/javascript/places
    // and https://developers.google.com/maps/documentation/javascript/places-autocomplete
    if (place && place.placeId && globals.maps && globals.map) {
      const service = new globals.maps.places.PlacesService(globals.map)
      const request = {
        placeId: place.placeId,
        fields: ['name', 'photo', 'url', 'rating', 'price_level', 'review'],
      }
      service.getDetails(request, getDetailsCallback) // see callback below
    } else {
      setDetails({})
    }
  }

  function getDetailsCallback(results, status) {
    if (status == globals.maps.places.PlacesServiceStatus.OK) {
      // add id's to reviews for react rendering
      if (results.reviews) {
        results.reviews.forEach(review => review.id = Math.random())
      }
      // fetch first photo - others on clicking carousel
      const photos = results.photos
      // console.log('photos', photos)
      if (photos && photos.length > 0) {
        const size = {'maxWidth': 200, 'maxHeight': 150}
        const url = photos[0].getUrl(size)
        photos[0].url = url
        results.photos = [photos[0]]
      }
      setDetails(results)
      setShowDetails(true)
    } else {
      alert('Error fetching details')
    }
  }

  return (
    <div className="sidebar-details">
      {!showDetails && <button onClick={fetchDetails}>Show Details</button>}
      {showDetails && details &&
        <>
          {details.photos &&
            <div className="sidebar-details-photos">
              <div className="sidebar-details-photo">
                <img src={details.photos[0].url} alt=""/>
              </div>
            </div>
          }
          {details.url && 
            <div className="sidebar-details-url">
              Go to <ExternalLink href={details.url}>Google Maps page</ExternalLink>
            </div>
          }
          {details.rating &&
            <div className="sidebar-details-rating">
              Average rating: {details.rating}
            </div>
          }
          {details.reviews && 
            <div className="sidebar-details-reviews">
              <div className="sidebar-details-reviews-title">Reviews</div>
              {details.reviews.map(review => (
                <div className="sidebar-details-review" key={review.id}>
                  <hr />
                  <div>Rating: {review.rating} ({review.relative_time_description})</div>
                  <Markdown source={review.text} />
                </div>
              ))}
            </div>
          }
        </>
      }
    </div>
  )
})
